export default __webpack_public_path__ + "static/media/pc-richard-logo.828d1a0e.webp";